
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as helpZTa7EaBoATrsTkO6xHZ7fBKXiQA3hkJD9nmC35Qk6DMMeta } from "/var/www/quickbooking/pages/help.vue?macro=true";
import { default as indexUPb1eWgfPCYQjcx3YwPev0OykMfpfh5_eG8RAOGazIIMeta } from "/var/www/quickbooking/pages/index.vue?macro=true";
import { default as login98qQS_45VTaTPDY_45aN3lrG2dgdB2_45zNQh5otU03FRvvWEMeta } from "/var/www/quickbooking/pages/login.vue?macro=true";
import { default as verifydB0D_45S2KvaM7ZGRDDAVZCsKsgG6XLLriB7lrd_45k0Ps8Meta } from "/var/www/quickbooking/pages/verify.vue?macro=true";
import { default as checkoutkMpbXweCZLaZb4plYa4cgtUS87xQcRPSIFvHlSRba8kMeta } from "/var/www/quickbooking/pages/checkout.vue?macro=true";
import { default as registervtf_45UAoQzvC8CxGlAUC6oNHbOOleRSay_45qqM5zB0ZNIMeta } from "/var/www/quickbooking/pages/register.vue?macro=true";
import { default as settingsdfI0qzQ6XZEIVJ7BK6Y7KhQkIqz61s15feXZ2q9qyIMMeta } from "/var/www/quickbooking/pages/settings.vue?macro=true";
import { default as onboardingwlEw2kwT4_daJyLFcLMbMkGWqqEtHT6pRWMJ2JCipX8Meta } from "/var/www/quickbooking/pages/onboarding.vue?macro=true";
import { default as marketplace_dVSlQYpiqDHStL431_45XRszrCD4KRka6vHZI9brW_45zwMeta } from "/var/www/quickbooking/pages/marketplace.vue?macro=true";
import { default as password_45resetluJdDDiifZiiF_45QU44zAFay5AhHRpS3UJ7i8GO9d7OAMeta } from "/var/www/quickbooking/pages/password-reset.vue?macro=true";
import { default as index6Z8zawOKr3fzVoru4oNNxhE5RXisDVf4iVlS5K2__45XwMeta } from "/var/www/quickbooking/pages/tutorial/index.vue?macro=true";
import { default as index5EJZMHdogsBm6ldJ3yI9zXF9AVrmlUS30FhosphmKjEMeta } from "/var/www/quickbooking/pages/dashboard/index.vue?macro=true";
import { default as index_45xz_NejAGIj4aaISRAk0L6Vmu8ACFMpMszrkzwNoL_kMeta } from "/var/www/quickbooking/pages/dev-diary/index.vue?macro=true";
import { default as _91slug_93vKMIpLG9f0IifrKLjRfFlPCJk3fZ8da1JXbWhAQdC3EMeta } from "/var/www/quickbooking/pages/dev-diary/[slug].vue?macro=true";
import { default as _91slug_93qOyXuC_WdVb4ZmAMtxitFXF2JTxTYdmuG6jXXnRRHpoMeta } from "/var/www/quickbooking/pages/servizi/[id]/[slug].vue?macro=true";
import { default as _91subdomain_93ButobdiirDQJOS_45URa521W89Nt7Gxr_DzMVRPadIZnIMeta } from "/var/www/quickbooking/pages/dashboard/[subdomain].vue?macro=true";
import { default as indexjN10hs_wZ8r3JLxyaKNZfh5uIIQVeeZWYS92_8WuZE4Meta } from "/var/www/quickbooking/pages/dashboard/admin/index.vue?macro=true";
import { default as indexA68TRM_TJErpJDBdOkazEmizVrkSSxOehGq6ysyi78sMeta } from "/var/www/quickbooking/pages/dashboard/admin/users/index.vue?macro=true";
import { default as indexTVcUqa0HRV_ktbqB_45dBFNz26UD4tuN1rCxTQuJwrN9oMeta } from "/var/www/quickbooking/pages/dashboard/admin/activities/index.vue?macro=true";
import { default as indexhVM0bfY20KOKhPB7SlkeEy0pGGgw8pDgE_457cC2wsrq4Meta } from "/var/www/quickbooking/pages/dashboard/admin/activity-types/index.vue?macro=true";
export default [
  {
    name: "help___it",
    path: "/help",
    meta: helpZTa7EaBoATrsTkO6xHZ7fBKXiQA3hkJD9nmC35Qk6DMMeta || {},
    component: () => import("/var/www/quickbooking/pages/help.vue")
  },
  {
    name: "index___it",
    path: "/",
    component: () => import("/var/www/quickbooking/pages/index.vue")
  },
  {
    name: "login___it",
    path: "/login",
    meta: login98qQS_45VTaTPDY_45aN3lrG2dgdB2_45zNQh5otU03FRvvWEMeta || {},
    component: () => import("/var/www/quickbooking/pages/login.vue")
  },
  {
    name: "verify___it",
    path: "/verify",
    component: () => import("/var/www/quickbooking/pages/verify.vue")
  },
  {
    name: "checkout___it",
    path: "/checkout",
    component: () => import("/var/www/quickbooking/pages/checkout.vue")
  },
  {
    name: "register___it",
    path: "/register",
    meta: registervtf_45UAoQzvC8CxGlAUC6oNHbOOleRSay_45qqM5zB0ZNIMeta || {},
    component: () => import("/var/www/quickbooking/pages/register.vue")
  },
  {
    name: "settings___it",
    path: "/settings",
    meta: settingsdfI0qzQ6XZEIVJ7BK6Y7KhQkIqz61s15feXZ2q9qyIMMeta || {},
    component: () => import("/var/www/quickbooking/pages/settings.vue")
  },
  {
    name: "onboarding___it",
    path: "/onboarding",
    meta: onboardingwlEw2kwT4_daJyLFcLMbMkGWqqEtHT6pRWMJ2JCipX8Meta || {},
    component: () => import("/var/www/quickbooking/pages/onboarding.vue")
  },
  {
    name: "marketplace___it",
    path: "/marketplace",
    meta: marketplace_dVSlQYpiqDHStL431_45XRszrCD4KRka6vHZI9brW_45zwMeta || {},
    component: () => import("/var/www/quickbooking/pages/marketplace.vue")
  },
  {
    name: "password-reset___it",
    path: "/password-reset",
    meta: password_45resetluJdDDiifZiiF_45QU44zAFay5AhHRpS3UJ7i8GO9d7OAMeta || {},
    component: () => import("/var/www/quickbooking/pages/password-reset.vue")
  },
  {
    name: "tutorial___it",
    path: "/tutorial",
    meta: index6Z8zawOKr3fzVoru4oNNxhE5RXisDVf4iVlS5K2__45XwMeta || {},
    component: () => import("/var/www/quickbooking/pages/tutorial/index.vue")
  },
  {
    name: "dashboard___it",
    path: "/dashboard",
    meta: index5EJZMHdogsBm6ldJ3yI9zXF9AVrmlUS30FhosphmKjEMeta || {},
    component: () => import("/var/www/quickbooking/pages/dashboard/index.vue")
  },
  {
    name: "dev-diary___it",
    path: "/dev-diary",
    meta: index_45xz_NejAGIj4aaISRAk0L6Vmu8ACFMpMszrkzwNoL_kMeta || {},
    component: () => import("/var/www/quickbooking/pages/dev-diary/index.vue")
  },
  {
    name: "dev-diary-slug___it",
    path: "/dev-diary/:slug()",
    meta: _91slug_93vKMIpLG9f0IifrKLjRfFlPCJk3fZ8da1JXbWhAQdC3EMeta || {},
    component: () => import("/var/www/quickbooking/pages/dev-diary/[slug].vue")
  },
  {
    name: "servizi-id-slug___it",
    path: "/servizi/:id()/:slug()",
    component: () => import("/var/www/quickbooking/pages/servizi/[id]/[slug].vue")
  },
  {
    name: "dashboard-subdomain___it",
    path: "/dashboard/:subdomain()",
    meta: _91subdomain_93ButobdiirDQJOS_45URa521W89Nt7Gxr_DzMVRPadIZnIMeta || {},
    component: () => import("/var/www/quickbooking/pages/dashboard/[subdomain].vue")
  },
  {
    name: "admin-dashboard___it",
    path: "/dashboard/admin",
    meta: indexjN10hs_wZ8r3JLxyaKNZfh5uIIQVeeZWYS92_8WuZE4Meta || {},
    component: () => import("/var/www/quickbooking/pages/dashboard/admin/index.vue")
  },
  {
    name: "admin-users___it",
    path: "/dashboard/admin/users",
    meta: indexA68TRM_TJErpJDBdOkazEmizVrkSSxOehGq6ysyi78sMeta || {},
    component: () => import("/var/www/quickbooking/pages/dashboard/admin/users/index.vue")
  },
  {
    name: "admin-activities___it",
    path: "/dashboard/admin/activities",
    meta: indexTVcUqa0HRV_ktbqB_45dBFNz26UD4tuN1rCxTQuJwrN9oMeta || {},
    component: () => import("/var/www/quickbooking/pages/dashboard/admin/activities/index.vue")
  },
  {
    name: "admin-activity-types___it",
    path: "/dashboard/admin/activity-types",
    meta: indexhVM0bfY20KOKhPB7SlkeEy0pGGgw8pDgE_457cC2wsrq4Meta || {},
    component: () => import("/var/www/quickbooking/pages/dashboard/admin/activity-types/index.vue")
  }
]